import React from 'react'
import { Button } from '@material-ui/core'
import { MessageSquareQuote } from 'lucide-react'
import { useStyles } from './style'

export const ButtonAddNew = ({
  label,
  onClick,
  className,
  startIcon,
  ...props
}) => {
  const classes = useStyles()

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={onClick}
      className={classes.button}
      startIcon={startIcon}
      {...props}
    >
      {label}
    </Button>
  )
}
